import { pickBy, has, mergeWith } from 'lodash';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const cssClassMerger = (defaultStyleClassName, themeClassName) => `${defaultStyleClassName} ${themeClassName}`;
const mergeStyles = ({
  styles,
  theme
}) => {
  if (!theme) {
    console.warn("mergeStyles invoked without theme!");
    return styles;
  }
  const themeStyles = pickBy(theme);
  const themeStylesToMerge = pickBy(themeStyles, (_, key) => has(styles, key));
  return mergeWith(__spreadValues({}, styles), themeStylesToMerge, cssClassMerger);
};

export { mergeStyles };
//# sourceMappingURL=mergeStyles.js.map
